module.exports = __webpack_public_path__ + "static/media/125.a730f239.webp";